if (!customElements.get("button-top")) {
  customElements.define(
    "button-top",
    class ButtonScrollTop extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector(".button-top");

        if (!this.button) {
          return;
        }

         this.scrollTimeout = null;
        this.resizeTimeout = null;

        window.addEventListener("scroll", () => {
          clearTimeout(this.scrollTimeout);

          this.scrollTimeout = setTimeout(() => {
            this.updateVisibility();
          }, 250);
        });

        window.addEventListener("resize", () => {
          clearTimeout(this.resizeTimeout);

          this.resizeTimeout = setTimeout(() => {
            this.updateVisibility();
          }, 150);
        });

        this.button.addEventListener("click", (event) => {
          event.preventDefault();
          this.handleClick();
        });

        // Set initial state
        this.updateVisibility();
      }

      updateVisibility() {
        this.button.classList.toggle(
          "button-top-visible",
          window.scrollY > 400 && window.innerWidth >= 1200
        );
      }

      handleClick() {
        document.documentElement.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  );
}
